import { render, staticRenderFns } from "./Send.html?vue&type=template&id=12843bbd&scoped=true&"
import script from "./Send.vue?vue&type=script&lang=ts&"
export * from "./Send.vue?vue&type=script&lang=ts&"
import style0 from "./Complete.scss?vue&type=style&index=0&id=12843bbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12843bbd",
  null
  
)

export default component.exports